// Global
import { useSitecore } from '@sitecore-content-sdk/nextjs';

/**
 * "Normal" mode means we are not in "edit" or "preview" mode.
 * @returns Whether we are rendering in "normal" mode.
 */
const useIsNormalMode = (): boolean => {
  const { page } = useSitecore();
  // This should only happen when we're running outside of Sitecore, e.g. Storybook and unit tests.
  if (!page?.mode) {
    return true;
  }
  return page.mode.isNormal;
};

export default useIsNormalMode;
